/* eslint-disable @typescript-eslint/no-explicit-any -- table not yet in generated types */
import { supabase } from "@/integrations/supabase/client";

export type PlatformRagSettings = {
  chunk_size_tokens: number;
  chunk_overlap_tokens: number;
  strategy: string;
  embedding_model: string;
  updated_at: string;
  updated_by: string | null;
};

export const RAG_DEFAULTS: PlatformRagSettings = {
  chunk_size_tokens: 800,
  chunk_overlap_tokens: 150,
  strategy: "recursive",
  embedding_model: "text-embedding-3-small",
  updated_at: new Date(0).toISOString(),
  updated_by: null,
};

export async function loadPlatformRagSettings(): Promise<PlatformRagSettings> {
  const { data, error } = await (supabase as any)
    .from("platform_rag_settings")
    .select("chunk_size_tokens, chunk_overlap_tokens, strategy, embedding_model, updated_at, updated_by")
    .eq("id", 1)
    .maybeSingle();
  if (error) throw error;
  return (data as PlatformRagSettings) ?? RAG_DEFAULTS;
}

export async function savePlatformRagSettings(input: {
  chunk_size_tokens: number;
  chunk_overlap_tokens: number;
}): Promise<void> {
  const { data: u } = await supabase.auth.getUser();
  const { error } = await (supabase as any)
    .from("platform_rag_settings")
    .update({
      chunk_size_tokens: input.chunk_size_tokens,
      chunk_overlap_tokens: input.chunk_overlap_tokens,
      updated_by: u.user?.id ?? null,
      updated_at: new Date().toISOString(),
    })
    .eq("id", 1);
  if (error) throw error;
}

export type ReembedResult = {
  processed: number;
  errors: number;
  workspaces?: Array<{ workspace_id: string; processed: number; errors: number }>;
};

export async function invokeAdminRagReembed(
  input: { scope: "workspace"; workspace_id: string } | { scope: "all" }
): Promise<ReembedResult> {
  const { data, error } = await supabase.functions.invoke("admin-rag-reembed", { body: input });
  if (error) throw error;
  return data as ReembedResult;
}
